import React from 'react';

const faqs = [
  { q: "O que significa Glasgow 3?", a: "Glasgow 3 é a pontuação mínima possível quando todos os componentes são testáveis. Indica ausência de abertura ocular, ausência de resposta verbal e ausência de resposta motora, sugerindo estado de coma profundo." },
  { q: "O que significa Glasgow 15?", a: "Glasgow 15 é a pontuação máxima. Indica que o paciente abre os olhos espontaneamente, está orientado e obedece a comandos motores, sugerindo nível de consciência preservado." },
  { q: "Quando intubar pelo Glasgow?", a: "Tradicionalmente, no trauma craniano, um escore ≤ 8 é indicativo de intubação para proteção de via aérea. No entanto, em casos clínicos gerais (intoxicação, pós-convulsão), a decisão depende da capacidade real do paciente de proteger a via aérea e do prognóstico imediato." },
  { q: "Como aplicar a escala em pacientes sedados?", a: "Pacientes sob sedação profunda ou bloqueio neuromuscular devem ter seus componentes registrados como Não Testáveis (NT). Idealmente, a avaliação neurológica deve ser feita durante a 'janela de sedação' (despertar diário)." },
  { q: "Como avaliar paciente intubado?", a: "Um paciente entubado não pode ter sua resposta verbal avaliada clinicamente de forma padronizada. Portanto, o componente verbal (V) deve ser registrado como NT (Não Testável), e a pontuação total não deve ser somada." },
  { q: "O que é resposta motora localizadora?", a: "É quando o paciente, após receber um estímulo de pressão central (como no trapézio ou incisura supraorbitária), eleva a mão acima do nível da clavícula na tentativa de remover o estímulo." },
  { q: "Qual a diferença do Glasgow antigo para o atual?", a: "A atualização mais recente enfatizou o registro separado dos componentes (EVM) em vez da pontuação total, clarificou a diferença entre flexão normal e anormal, e instituiu formalmente o uso do status 'Não Testável' (NT) em vez de forçar a pontuação 1." },
  { q: "Quem criou a Escala de Glasgow?", a: "A escala foi publicada pela primeira vez em 1974 pelos professores de neurocirurgia Graham Teasdale e Bryan Jennett da Universidade de Glasgow, na Escócia." }
];

const FAQ = () => {
  return (
    <section className="faq">
      <div>
        <h2 className="h2">
          <span className="h2__n">PERGUNTAS FREQUENTES</span>
        </h2>
        {faqs.map((faq, index) => (
          <details key={index}>
            <summary>{faq.q}</summary>
            <div>{faq.a}</div>
          </details>
        ))}
      </div>
    </section>
  );
};

export default FAQ;